<template>
    <svg
        v-if="type === 'member'"
        fill="none"
        viewBox="0 0 380 245"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1_3796)">
            <rect
                fill="white"
                height="215"
                rx="11.9079"
                width="349.869"
                x="15"
                y="13"
            />
            <text
                dominant-baseline="middle"
                fill="black"
                font-size="0.9rem"
                opacity="0.78"
                text-anchor="middle"
                x="190"
                y="199"
            >
                {{ uppercaseName }}
            </text>
            <path
                d="M100 100H280V122.106H100V100Z"
                fill="black"
            />
            <path
                d="M215.584 113.19L216.983 112.324C217.15 114.057 218.216 115.556 220.364 115.556C221.83 115.556 222.979 114.823 222.979 113.557C222.979 111.925 221.13 111.725 219.465 111.192C217.999 110.725 215.984 110.142 215.984 108.077C215.984 106.145 217.599 104.929 219.648 104.929C221.513 104.929 223.429 105.879 224.178 108.11L222.779 108.977C222.546 107.294 221.314 106.228 219.648 106.228C218.449 106.228 217.449 106.878 217.449 107.944C217.449 109.376 219.298 109.593 220.897 110.109C222.646 110.675 224.445 111.358 224.445 113.49C224.445 115.489 222.763 116.855 220.364 116.855C218.032 116.855 216.05 115.572 215.584 113.19Z"
                fill="white"
            />
            <path
                d="M203.756 113.19L205.155 112.324C205.321 114.057 206.387 115.556 208.536 115.556C210.002 115.556 211.151 114.823 211.151 113.557C211.151 111.925 209.302 111.725 207.637 111.192C206.171 110.725 204.156 110.142 204.156 108.077C204.156 106.145 205.771 104.929 207.82 104.929C209.685 104.929 211.601 105.879 212.35 108.11L210.951 108.977C210.718 107.294 209.485 106.228 207.82 106.228C206.621 106.228 205.621 106.878 205.621 107.944C205.621 109.376 207.47 109.593 209.069 110.109C210.818 110.675 212.617 111.358 212.617 113.49C212.617 115.489 210.934 116.855 208.536 116.855C206.204 116.855 204.222 115.572 203.756 113.19Z"
                fill="white"
            />
            <path
                d="M193.391 116.656V105.13H200.652V106.462H194.856V110.06H200.386V111.392H194.856V115.323H200.786V116.656H193.391Z"
                fill="white"
            />
            <path
                d="M180.234 110.859C180.234 107.144 182.5 104.929 185.298 104.929C187.963 104.929 189.695 106.861 189.895 108.727L188.496 109.593C188.362 107.727 187.363 106.262 185.298 106.262C182.949 106.262 181.733 108.26 181.733 110.859C181.733 113.457 182.949 115.522 185.298 115.522C187.363 115.522 188.362 113.99 188.496 112.124L189.895 112.991C189.695 114.856 187.963 116.855 185.298 116.855C182.5 116.855 180.234 114.59 180.234 110.859Z"
                fill="white"
            />
            <path
                d="M167.608 110.859C167.608 107.144 169.874 104.929 172.672 104.929C175.337 104.929 177.069 106.861 177.269 108.727L175.87 109.593C175.736 107.727 174.737 106.262 172.672 106.262C170.323 106.262 169.107 108.26 169.107 110.859C169.107 113.457 170.323 115.522 172.672 115.522C174.737 115.522 175.736 113.99 175.87 112.124L177.269 112.991C177.069 114.856 175.337 116.855 172.672 116.855C169.874 116.855 167.608 114.59 167.608 110.859Z"
                fill="white"
            />
            <path
                d="M163.925 116.656L162.759 113.391H157.929L156.763 116.656H155.264L159.494 105.13H161.21L165.44 116.656H163.925ZM158.378 112.125H162.309L160.927 108.261C160.71 107.662 160.36 106.529 160.36 106.529H160.327C160.327 106.529 159.977 107.662 159.761 108.261L158.378 112.125Z"
                fill="white"
            />
            <path
                d="M272.204 139.762V128.227H279.472V129.561H273.671V133.161H279.205V134.495H273.671V138.428H279.605V139.762H272.204Z"
                fill="black"
            />
            <path
                d="M263.305 128.227L265.306 136.662C265.439 137.245 265.622 138.295 265.622 138.295H265.656C265.656 138.295 265.789 137.245 265.906 136.662L267.673 128.227H269.14L266.589 139.762H264.722L262.722 131.427C262.522 130.611 262.389 129.694 262.389 129.694H262.355C262.355 129.694 262.222 130.611 262.022 131.427L260.022 139.762H258.155L255.604 128.227H257.105L258.872 136.662C258.988 137.245 259.122 138.295 259.122 138.295H259.155C259.155 138.295 259.338 137.245 259.472 136.662L261.472 128.227H263.305Z"
                fill="black"
            />
            <path
                d="M245.731 139.762V128.227H252.999V129.561H247.198V133.161H252.732V134.495H247.198V138.428H253.132V139.762H245.731Z"
                fill="black"
            />
            <path
                d="M232.689 128.227H236.557C239.824 128.227 242.091 130.227 242.091 133.961C242.091 137.695 239.824 139.762 236.557 139.762H232.689V128.227ZM234.156 129.561V138.428H236.973C239.274 138.428 240.59 136.495 240.59 133.961C240.59 131.427 239.274 129.561 236.973 129.561H234.156Z"
                fill="black"
            />
            <path
                d="M228.142 139.762L226.976 136.495H222.142L220.975 139.762H219.475L223.708 128.227H225.425L229.659 139.762H228.142ZM222.592 135.228H226.525L225.142 131.361C224.925 130.761 224.575 129.627 224.575 129.627H224.542C224.542 129.627 224.192 130.761 223.975 131.361L222.592 135.228Z"
                fill="black"
            />
            <path
                d="M217.14 128.227L213.373 132.628L217.84 139.762H216.157L212.406 133.744L210.239 136.278V139.762H208.806V128.227H210.239V132.294C210.239 133.428 210.206 134.428 210.206 134.428H210.239C210.239 134.428 210.806 133.578 211.673 132.561L215.34 128.227H217.14Z"
                fill="black"
            />
            <path
                d="M193.27 139.762V128.227H200.404V129.561H194.736V133.228H200.137V134.561H194.736V139.762H193.27Z"
                fill="black"
            />
            <path
                d="M179.239 133.96C179.239 130.227 181.573 128.026 184.44 128.026C187.307 128.026 189.641 130.227 189.641 133.96C189.641 137.694 187.307 139.961 184.44 139.961C181.573 139.961 179.239 137.694 179.239 133.96ZM180.739 133.96C180.739 136.561 182.023 138.628 184.44 138.628C186.857 138.628 188.14 136.561 188.14 133.96C188.14 131.36 186.857 129.36 184.44 129.36C182.023 129.36 180.739 131.36 180.739 133.96Z"
                fill="black"
            />
            <path
                d="M162.107 136.294L163.508 135.427C163.674 137.161 164.741 138.661 166.891 138.661C168.358 138.661 169.508 137.928 169.508 136.661C169.508 135.027 167.658 134.827 165.991 134.294C164.524 133.827 162.507 133.244 162.507 131.177C162.507 129.243 164.124 128.026 166.175 128.026C168.041 128.026 169.958 128.976 170.708 131.21L169.308 132.077C169.075 130.393 167.841 129.327 166.175 129.327C164.974 129.327 163.974 129.977 163.974 131.043C163.974 132.477 165.825 132.694 167.425 133.21C169.175 133.777 170.975 134.461 170.975 136.594C170.975 138.594 169.292 139.961 166.891 139.961C164.558 139.961 162.574 138.678 162.107 136.294Z"
                fill="black"
            />
            <path
                d="M151.734 139.762V128.227H159.002V129.561H153.201V133.161H158.735V134.495H153.201V138.428H159.135V139.762H151.734Z"
                fill="black"
            />
            <path
                d="M139.363 136.294L140.763 135.427C140.93 137.161 141.997 138.661 144.147 138.661C145.614 138.661 146.764 137.928 146.764 136.661C146.764 135.027 144.914 134.827 143.247 134.294C141.78 133.827 139.763 133.244 139.763 131.177C139.763 129.243 141.38 128.026 143.43 128.026C145.297 128.026 147.214 128.976 147.964 131.21L146.564 132.077C146.331 130.393 145.097 129.327 143.43 129.327C142.23 129.327 141.23 129.977 141.23 131.043C141.23 132.477 143.08 132.694 144.681 133.21C146.431 133.777 148.231 134.461 148.231 136.594C148.231 138.594 146.548 139.961 144.147 139.961C141.814 139.961 139.83 138.678 139.363 136.294Z"
                fill="black"
            />
            <path
                d="M127.195 128.227H128.662V135.111C128.662 137.445 129.696 138.628 131.563 138.628C133.429 138.628 134.463 137.445 134.463 135.111V128.227H135.93V135.045C135.93 138.312 134.296 139.962 131.563 139.962C128.829 139.962 127.195 138.312 127.195 135.045V128.227Z"
                fill="black"
            />
            <path
                d="M113.232 133.96C113.232 130.227 115.566 128.026 118.433 128.026C121.3 128.026 123.634 130.227 123.634 133.96C123.634 137.694 121.3 139.961 118.433 139.961C115.566 139.961 113.232 137.694 113.232 133.96ZM114.733 133.96C114.733 136.561 116.016 138.628 118.433 138.628C120.85 138.628 122.134 136.561 122.134 133.96C122.134 131.36 120.85 129.36 118.433 129.36C116.016 129.36 114.733 131.36 114.733 133.96Z"
                fill="black"
            />
            <path
                d="M108.123 139.762V134.495H102.256V139.762H100.789V128.227H102.256V133.161H108.123V128.227H109.59V139.762H108.123Z"
                fill="black"
            />
            <path
                d="M151.015 43.084C151.015 39.293 153.327 37.032 156.183 37.032C158.903 37.032 160.671 39.004 160.875 40.908L159.447 41.792C159.311 39.888 158.291 38.392 156.183 38.392C153.786 38.392 152.545 40.432 152.545 43.084C152.545 45.736 153.786 47.844 156.183 47.844C158.291 47.844 159.311 46.28 159.447 44.376L160.875 45.26C160.671 47.164 158.903 49.204 156.183 49.204C153.327 49.204 151.015 46.892 151.015 43.084ZM164.915 49V37.236H166.411V47.64H172.055V49H164.915ZM183.63 49L182.44 45.668H177.51L176.32 49H174.79L179.108 37.236H180.859L185.177 49H183.63ZM177.969 44.376H181.981L180.57 40.432C180.349 39.82 179.992 38.664 179.992 38.664H179.958C179.958 38.664 179.601 39.82 179.38 40.432L177.969 44.376ZM187.926 45.464L189.354 44.58C189.524 46.348 190.612 47.878 192.805 47.878C194.301 47.878 195.474 47.13 195.474 45.838C195.474 44.172 193.587 43.968 191.887 43.424C190.391 42.948 188.334 42.353 188.334 40.245C188.334 38.273 189.983 37.032 192.074 37.032C193.978 37.032 195.933 38.001 196.698 40.279L195.27 41.163C195.032 39.446 193.774 38.358 192.074 38.358C190.85 38.358 189.83 39.021 189.83 40.109C189.83 41.571 191.717 41.792 193.349 42.319C195.134 42.897 196.97 43.594 196.97 45.77C196.97 47.81 195.253 49.204 192.805 49.204C190.425 49.204 188.402 47.895 187.926 45.464ZM200.468 45.464L201.896 44.58C202.066 46.348 203.154 47.878 205.347 47.878C206.843 47.878 208.016 47.13 208.016 45.838C208.016 44.172 206.129 43.968 204.429 43.424C202.933 42.948 200.876 42.353 200.876 40.245C200.876 38.273 202.525 37.032 204.616 37.032C206.52 37.032 208.475 38.001 209.24 40.279L207.812 41.163C207.574 39.446 206.316 38.358 204.616 38.358C203.392 38.358 202.372 39.021 202.372 40.109C202.372 41.571 204.259 41.792 205.891 42.319C207.676 42.897 209.512 43.594 209.512 45.77C209.512 47.81 207.795 49.204 205.347 49.204C202.967 49.204 200.944 47.895 200.468 45.464ZM213.555 49V37.236H215.085V49H213.555ZM219.261 43.084C219.261 39.293 221.573 37.032 224.429 37.032C227.149 37.032 228.917 39.004 229.121 40.908L227.693 41.792C227.557 39.888 226.537 38.392 224.429 38.392C222.032 38.392 220.791 40.432 220.791 43.084C220.791 45.736 222.032 47.844 224.429 47.844C226.537 47.844 227.557 46.28 227.693 44.376L229.121 45.26C228.917 47.164 227.149 49.204 224.429 49.204C221.573 49.204 219.261 46.892 219.261 43.084Z"
                fill="black"
                opacity="0.78"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1_3796"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="245"
                width="379.869"
                x="0"
                y="0"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_1_3796"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_3796"
                    mode="normal"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
    <svg
        v-else-if="type === 'premium'"
        fill="none"
        viewBox="0 0 380 245"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1_3916)">
            <rect
                fill="black"
                height="215"
                rx="11.9079"
                width="349.869"
                x="15"
                y="13"
            />
            <text
                dominant-baseline="middle"
                fill="white"
                font-size="0.9rem"
                opacity="0.78"
                text-anchor="middle"
                x="190"
                y="199"
            >
                {{ uppercaseName }}
            </text>
            <path
                d="M100 100H280V122.106H100V100Z"
                fill="white"
            />
            <path
                d="M215.584 113.19L216.983 112.324C217.15 114.057 218.216 115.556 220.364 115.556C221.83 115.556 222.979 114.823 222.979 113.557C222.979 111.925 221.13 111.725 219.465 111.192C217.999 110.725 215.984 110.142 215.984 108.077C215.984 106.145 217.599 104.929 219.648 104.929C221.513 104.929 223.429 105.879 224.178 108.11L222.779 108.977C222.546 107.294 221.314 106.228 219.648 106.228C218.449 106.228 217.449 106.878 217.449 107.944C217.449 109.376 219.298 109.593 220.897 110.109C222.646 110.675 224.445 111.358 224.445 113.49C224.445 115.489 222.763 116.855 220.364 116.855C218.032 116.855 216.05 115.572 215.584 113.19Z"
                fill="black"
            />
            <path
                d="M203.756 113.19L205.155 112.324C205.321 114.057 206.387 115.556 208.536 115.556C210.002 115.556 211.151 114.823 211.151 113.557C211.151 111.925 209.302 111.725 207.637 111.192C206.171 110.725 204.156 110.142 204.156 108.077C204.156 106.145 205.771 104.929 207.82 104.929C209.685 104.929 211.601 105.879 212.35 108.11L210.951 108.977C210.718 107.294 209.485 106.228 207.82 106.228C206.621 106.228 205.621 106.878 205.621 107.944C205.621 109.376 207.47 109.593 209.069 110.109C210.818 110.675 212.617 111.358 212.617 113.49C212.617 115.489 210.934 116.855 208.536 116.855C206.204 116.855 204.222 115.572 203.756 113.19Z"
                fill="black"
            />
            <path
                d="M193.391 116.656V105.13H200.652V106.462H194.856V110.06H200.386V111.392H194.856V115.323H200.786V116.656H193.391Z"
                fill="black"
            />
            <path
                d="M180.234 110.859C180.234 107.144 182.5 104.929 185.298 104.929C187.963 104.929 189.695 106.861 189.895 108.727L188.496 109.593C188.362 107.727 187.363 106.262 185.298 106.262C182.949 106.262 181.733 108.26 181.733 110.859C181.733 113.457 182.949 115.522 185.298 115.522C187.363 115.522 188.362 113.99 188.496 112.124L189.895 112.991C189.695 114.856 187.963 116.855 185.298 116.855C182.5 116.855 180.234 114.59 180.234 110.859Z"
                fill="black"
            />
            <path
                d="M167.608 110.859C167.608 107.144 169.874 104.929 172.672 104.929C175.337 104.929 177.069 106.861 177.269 108.727L175.87 109.593C175.736 107.727 174.737 106.262 172.672 106.262C170.323 106.262 169.107 108.26 169.107 110.859C169.107 113.457 170.323 115.522 172.672 115.522C174.737 115.522 175.736 113.99 175.87 112.124L177.269 112.991C177.069 114.856 175.337 116.855 172.672 116.855C169.874 116.855 167.608 114.59 167.608 110.859Z"
                fill="black"
            />
            <path
                d="M163.925 116.656L162.759 113.391H157.929L156.763 116.656H155.264L159.494 105.13H161.21L165.44 116.656H163.925ZM158.378 112.125H162.309L160.927 108.261C160.71 107.662 160.36 106.529 160.36 106.529H160.327C160.327 106.529 159.977 107.662 159.761 108.261L158.378 112.125Z"
                fill="black"
            />
            <path
                d="M272.204 139.762V128.227H279.472V129.561H273.671V133.161H279.205V134.495H273.671V138.428H279.605V139.762H272.204Z"
                fill="white"
            />
            <path
                d="M263.305 128.227L265.306 136.662C265.439 137.245 265.622 138.295 265.622 138.295H265.656C265.656 138.295 265.789 137.245 265.906 136.662L267.673 128.227H269.14L266.589 139.762H264.722L262.722 131.427C262.522 130.611 262.389 129.694 262.389 129.694H262.355C262.355 129.694 262.222 130.611 262.022 131.427L260.022 139.762H258.155L255.604 128.227H257.105L258.872 136.662C258.988 137.245 259.122 138.295 259.122 138.295H259.155C259.155 138.295 259.338 137.245 259.472 136.662L261.472 128.227H263.305Z"
                fill="white"
            />
            <path
                d="M245.731 139.762V128.227H252.999V129.561H247.198V133.161H252.732V134.495H247.198V138.428H253.132V139.762H245.731Z"
                fill="white"
            />
            <path
                d="M232.689 128.227H236.557C239.824 128.227 242.091 130.227 242.091 133.961C242.091 137.695 239.824 139.762 236.557 139.762H232.689V128.227ZM234.156 129.561V138.428H236.973C239.274 138.428 240.59 136.495 240.59 133.961C240.59 131.427 239.274 129.561 236.973 129.561H234.156Z"
                fill="white"
            />
            <path
                d="M228.142 139.762L226.976 136.495H222.142L220.975 139.762H219.475L223.708 128.227H225.425L229.659 139.762H228.142ZM222.592 135.228H226.525L225.142 131.361C224.925 130.761 224.575 129.627 224.575 129.627H224.542C224.542 129.627 224.192 130.761 223.975 131.361L222.592 135.228Z"
                fill="white"
            />
            <path
                d="M217.14 128.227L213.373 132.628L217.84 139.762H216.157L212.406 133.744L210.239 136.278V139.762H208.806V128.227H210.239V132.294C210.239 133.428 210.206 134.428 210.206 134.428H210.239C210.239 134.428 210.806 133.578 211.673 132.561L215.34 128.227H217.14Z"
                fill="white"
            />
            <path
                d="M193.27 139.762V128.227H200.404V129.561H194.736V133.228H200.137V134.561H194.736V139.762H193.27Z"
                fill="white"
            />
            <path
                d="M179.239 133.96C179.239 130.227 181.573 128.026 184.44 128.026C187.307 128.026 189.641 130.227 189.641 133.96C189.641 137.694 187.307 139.961 184.44 139.961C181.573 139.961 179.239 137.694 179.239 133.96ZM180.739 133.96C180.739 136.561 182.023 138.628 184.44 138.628C186.857 138.628 188.14 136.561 188.14 133.96C188.14 131.36 186.857 129.36 184.44 129.36C182.023 129.36 180.739 131.36 180.739 133.96Z"
                fill="white"
            />
            <path
                d="M162.107 136.294L163.508 135.427C163.674 137.161 164.741 138.661 166.891 138.661C168.358 138.661 169.508 137.928 169.508 136.661C169.508 135.027 167.658 134.827 165.991 134.294C164.524 133.827 162.507 133.244 162.507 131.177C162.507 129.243 164.124 128.026 166.175 128.026C168.041 128.026 169.958 128.976 170.708 131.21L169.308 132.077C169.075 130.393 167.841 129.327 166.175 129.327C164.974 129.327 163.974 129.977 163.974 131.043C163.974 132.477 165.825 132.694 167.425 133.21C169.175 133.777 170.975 134.461 170.975 136.594C170.975 138.594 169.292 139.961 166.891 139.961C164.558 139.961 162.574 138.678 162.107 136.294Z"
                fill="white"
            />
            <path
                d="M151.734 139.762V128.227H159.002V129.561H153.201V133.161H158.735V134.495H153.201V138.428H159.135V139.762H151.734Z"
                fill="white"
            />
            <path
                d="M139.363 136.294L140.763 135.427C140.93 137.161 141.997 138.661 144.147 138.661C145.614 138.661 146.764 137.928 146.764 136.661C146.764 135.027 144.914 134.827 143.247 134.294C141.78 133.827 139.763 133.244 139.763 131.177C139.763 129.243 141.38 128.026 143.43 128.026C145.297 128.026 147.214 128.976 147.964 131.21L146.564 132.077C146.331 130.393 145.097 129.327 143.43 129.327C142.23 129.327 141.23 129.977 141.23 131.043C141.23 132.477 143.08 132.694 144.681 133.21C146.431 133.777 148.231 134.461 148.231 136.594C148.231 138.594 146.548 139.961 144.147 139.961C141.814 139.961 139.83 138.678 139.363 136.294Z"
                fill="white"
            />
            <path
                d="M127.195 128.227H128.662V135.111C128.662 137.445 129.696 138.628 131.563 138.628C133.429 138.628 134.463 137.445 134.463 135.111V128.227H135.93V135.045C135.93 138.312 134.296 139.962 131.563 139.962C128.829 139.962 127.195 138.312 127.195 135.045V128.227Z"
                fill="white"
            />
            <path
                d="M113.232 133.96C113.232 130.227 115.566 128.026 118.433 128.026C121.3 128.026 123.634 130.227 123.634 133.96C123.634 137.694 121.3 139.961 118.433 139.961C115.566 139.961 113.232 137.694 113.232 133.96ZM114.733 133.96C114.733 136.561 116.016 138.628 118.433 138.628C120.85 138.628 122.134 136.561 122.134 133.96C122.134 131.36 120.85 129.36 118.433 129.36C116.016 129.36 114.733 131.36 114.733 133.96Z"
                fill="white"
            />
            <path
                d="M108.123 139.762V134.495H102.256V139.762H100.789V128.227H102.256V133.161H108.123V128.227H109.59V139.762H108.123Z"
                fill="white"
            />
            <path
                d="M148.006 49V37.236H152.63C155.214 37.236 156.744 38.46 156.744 40.636C156.744 42.812 155.214 44.104 152.63 44.104H149.502V49H148.006ZM155.214 40.636C155.214 39.208 154.33 38.596 152.834 38.596H149.502V42.744H152.834C154.33 42.744 155.214 42.064 155.214 40.636ZM169.117 40.568C169.117 42.268 168.029 43.339 166.584 43.764L169.389 49H167.757L165.054 43.968H162.011V49H160.515V37.236H165.003C167.587 37.236 169.117 38.528 169.117 40.568ZM162.011 42.608H165.207C166.703 42.608 167.587 41.911 167.587 40.568C167.587 39.242 166.703 38.596 165.207 38.596H162.011V42.608ZM173.157 49V37.236H180.569V38.596H174.653V42.268H180.297V43.628H174.653V47.64H180.705V49H173.157ZM190.548 47.096H190.582C190.582 47.096 190.837 46.076 191.177 45.124L193.965 37.236H196.243V49H194.781V41.044C194.781 39.888 194.815 38.868 194.815 38.868H194.781C194.781 38.868 194.407 39.956 194.067 40.908L191.211 49H189.851L186.995 40.908C186.655 39.956 186.281 38.868 186.281 38.868H186.247C186.247 38.868 186.281 39.888 186.281 41.044V49H184.819V37.236H187.165L189.953 45.124C190.293 46.076 190.548 47.096 190.548 47.096ZM200.964 49V37.236H202.494V49H200.964ZM207.078 37.236H208.574V44.257C208.574 46.637 209.628 47.844 211.532 47.844C213.436 47.844 214.49 46.637 214.49 44.257V37.236H215.986V44.189C215.986 47.521 214.32 49.204 211.532 49.204C208.744 49.204 207.078 47.521 207.078 44.189V37.236ZM226.298 47.096H226.332C226.332 47.096 226.587 46.076 226.927 45.124L229.715 37.236H231.993V49H230.531V41.044C230.531 39.888 230.565 38.868 230.565 38.868H230.531C230.531 38.868 230.157 39.956 229.817 40.908L226.961 49H225.601L222.745 40.908C222.405 39.956 222.031 38.868 222.031 38.868H221.997C221.997 38.868 222.031 39.888 222.031 41.044V49H220.569V37.236H222.915L225.703 45.124C226.043 46.076 226.298 47.096 226.298 47.096Z"
                fill="white"
                opacity="0.78"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1_3916"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="245"
                width="379.869"
                x="0"
                y="0"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_1_3916"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_3916"
                    mode="normal"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
    <svg
        v-else-if="type === 'superior'"
        fill="none"
        viewBox="0 0 380 245"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1_3826)">
            <rect
                fill="white"
                height="215"
                rx="11.9079"
                width="349.869"
                x="15"
                y="13"
            />
            <text
                dominant-baseline="middle"
                fill="#A0A0A0"
                font-size="0.9rem"
                opacity="0.78"
                text-anchor="middle"
                x="190"
                y="199"
            >
                {{ uppercaseName }}
            </text>
            <path
                d="M279.5 100.5V121.606H100.5V100.5H279.5Z"
                stroke="url(#paint0_linear_1_3826)"
            />
            <path
                d="M215.584 113.19L216.983 112.324C217.15 114.057 218.216 115.556 220.364 115.556C221.83 115.556 222.979 114.823 222.979 113.557C222.979 111.925 221.13 111.725 219.465 111.192C217.999 110.725 215.984 110.142 215.984 108.077C215.984 106.145 217.599 104.929 219.648 104.929C221.513 104.929 223.429 105.879 224.178 108.11L222.779 108.977C222.546 107.294 221.314 106.228 219.648 106.228C218.449 106.228 217.449 106.878 217.449 107.944C217.449 109.376 219.298 109.593 220.897 110.109C222.646 110.675 224.445 111.358 224.445 113.49C224.445 115.489 222.763 116.855 220.364 116.855C218.032 116.855 216.05 115.572 215.584 113.19Z"
                fill="url(#paint1_linear_1_3826)"
            />
            <path
                d="M203.756 113.19L205.155 112.324C205.321 114.057 206.387 115.556 208.536 115.556C210.002 115.556 211.151 114.823 211.151 113.557C211.151 111.925 209.302 111.725 207.637 111.192C206.171 110.725 204.156 110.142 204.156 108.077C204.156 106.145 205.771 104.929 207.82 104.929C209.685 104.929 211.601 105.879 212.35 108.11L210.951 108.977C210.718 107.294 209.485 106.228 207.82 106.228C206.621 106.228 205.621 106.878 205.621 107.944C205.621 109.376 207.47 109.593 209.069 110.109C210.818 110.675 212.617 111.358 212.617 113.49C212.617 115.489 210.934 116.855 208.536 116.855C206.204 116.855 204.222 115.572 203.756 113.19Z"
                fill="url(#paint2_linear_1_3826)"
            />
            <path
                d="M193.391 116.656V105.13H200.652V106.462H194.856V110.06H200.386V111.392H194.856V115.323H200.786V116.656H193.391Z"
                fill="url(#paint3_linear_1_3826)"
            />
            <path
                d="M180.234 110.859C180.234 107.144 182.5 104.929 185.298 104.929C187.963 104.929 189.695 106.861 189.895 108.727L188.496 109.593C188.362 107.727 187.363 106.262 185.298 106.262C182.949 106.262 181.733 108.26 181.733 110.859C181.733 113.457 182.949 115.522 185.298 115.522C187.363 115.522 188.362 113.99 188.496 112.124L189.895 112.991C189.695 114.856 187.963 116.855 185.298 116.855C182.5 116.855 180.234 114.59 180.234 110.859Z"
                fill="url(#paint4_linear_1_3826)"
            />
            <path
                d="M167.608 110.859C167.608 107.144 169.874 104.929 172.672 104.929C175.337 104.929 177.069 106.861 177.269 108.727L175.87 109.593C175.736 107.727 174.737 106.262 172.672 106.262C170.323 106.262 169.107 108.26 169.107 110.859C169.107 113.457 170.323 115.522 172.672 115.522C174.737 115.522 175.736 113.99 175.87 112.124L177.269 112.991C177.069 114.856 175.337 116.855 172.672 116.855C169.874 116.855 167.608 114.59 167.608 110.859Z"
                fill="url(#paint5_linear_1_3826)"
            />
            <path
                d="M163.925 116.656L162.759 113.391H157.929L156.763 116.656H155.264L159.494 105.13H161.21L165.44 116.656H163.925ZM158.378 112.125H162.309L160.927 108.261C160.71 107.662 160.36 106.529 160.36 106.529H160.327C160.327 106.529 159.977 107.662 159.761 108.261L158.378 112.125Z"
                fill="url(#paint6_linear_1_3826)"
            />
            <path
                d="M128.662 135.111C128.662 137.445 129.696 138.629 131.562 138.629C133.429 138.629 134.463 137.445 134.463 135.111V128.228H135.93V135.045C135.93 138.312 134.296 139.962 131.562 139.962C128.829 139.962 127.195 138.312 127.195 135.045V128.228H128.662V135.111ZM118.433 128.026C121.3 128.026 123.634 130.227 123.634 133.961C123.634 137.695 121.3 139.961 118.433 139.961C115.566 139.961 113.233 137.694 113.232 133.961C113.232 130.227 115.566 128.027 118.433 128.026ZM143.431 128.026C145.297 128.026 147.214 128.977 147.964 131.21L146.564 132.077C146.331 130.394 145.097 129.326 143.431 129.326C142.231 129.326 141.231 129.976 141.23 131.043C141.23 132.476 143.08 132.693 144.681 133.21C146.431 133.777 148.231 134.46 148.231 136.594C148.231 138.594 146.548 139.961 144.147 139.961C141.814 139.961 139.83 138.678 139.363 136.294L140.764 135.428C140.93 137.161 141.997 138.661 144.147 138.661C145.614 138.661 146.764 137.928 146.765 136.661C146.765 135.028 144.914 134.827 143.247 134.294C141.78 133.827 139.764 133.244 139.764 131.177C139.764 129.243 141.38 128.026 143.431 128.026ZM166.176 128.026C168.043 128.026 169.959 128.977 170.709 131.21L169.31 132.077C169.076 130.394 167.843 129.326 166.176 129.326C164.976 129.326 163.976 129.976 163.976 131.043C163.976 132.476 165.826 132.693 167.426 133.21C169.176 133.777 170.976 134.46 170.977 136.594C170.977 138.594 169.293 139.961 166.893 139.961C164.559 139.961 162.575 138.678 162.108 136.294L163.509 135.428C163.676 137.161 164.742 138.661 166.893 138.661C168.359 138.661 169.51 137.928 169.51 136.661C169.51 135.028 167.659 134.827 165.992 134.294C164.525 133.827 162.509 133.244 162.509 131.177C162.509 129.243 164.126 128.026 166.176 128.026ZM184.44 128.026C187.307 128.026 189.642 130.227 189.642 133.961C189.641 137.695 187.307 139.961 184.44 139.961C181.574 139.961 179.24 137.694 179.24 133.961C179.24 130.227 181.574 128.027 184.44 128.026ZM102.257 133.161H108.124V128.228H109.591V139.762H108.124V134.494H102.257V139.762H100.79V128.228H102.257V133.161ZM159.002 129.561H153.201V133.161H158.735V134.494H153.201V138.429H159.136V139.762H151.734V128.228H159.002V129.561ZM200.403 129.561H194.736V133.228H200.137V134.562H194.736V139.762H193.27V128.228H200.403V129.561ZM210.24 132.294C210.24 133.419 210.207 134.414 210.207 134.428H210.24C210.249 134.415 210.813 133.57 211.674 132.561L215.341 128.228H217.141L213.374 132.628L217.841 139.762H216.157L212.407 133.744L210.24 136.278V139.762H208.807V128.228H210.24V132.294ZM229.659 139.762H228.143L226.976 136.495H222.142L220.975 139.762H219.475L223.708 128.228H225.426L229.659 139.762ZM236.558 128.228C239.825 128.228 242.092 130.227 242.092 133.961C242.092 137.695 239.825 139.762 236.558 139.762H232.69V128.228H236.558ZM253 129.561H247.199V133.161H252.733V134.494H247.199V138.429H253.134V139.762H245.732V128.228H253V129.561ZM258.872 136.661C258.988 137.242 259.122 138.284 259.123 138.295H259.156C259.159 138.279 259.34 137.24 259.473 136.661L261.473 128.228H263.307L265.307 136.661C265.439 137.24 265.62 138.279 265.623 138.295H265.656C265.658 138.284 265.791 137.242 265.907 136.661L267.674 128.228H269.141L266.59 139.762H264.724L262.723 131.428C262.525 130.621 262.393 129.716 262.39 129.694H262.356C262.353 129.716 262.22 130.621 262.022 131.428L260.022 139.762H258.156L255.605 128.228H257.105L258.872 136.661ZM279.473 129.561H273.672V133.161H279.206V134.494H273.672V138.429H279.606V139.762H272.205V128.228H279.473V129.561ZM118.433 129.36C116.016 129.361 114.732 131.361 114.732 133.961C114.733 136.561 116.016 138.628 118.433 138.628C120.849 138.628 122.134 136.561 122.134 133.961C122.134 131.361 120.85 129.36 118.433 129.36ZM184.44 129.36C182.024 129.361 180.74 131.361 180.74 133.961C180.74 136.561 182.024 138.628 184.44 138.628C186.857 138.628 188.141 136.561 188.142 133.961C188.142 131.361 186.857 129.36 184.44 129.36ZM234.157 138.429H236.975C239.275 138.429 240.592 136.494 240.592 133.961C240.592 131.427 239.275 129.561 236.975 129.561H234.157V138.429ZM224.542 129.627C224.542 129.627 224.192 130.76 223.976 131.36L222.592 135.228H226.525L225.142 131.36C224.925 130.76 224.575 129.627 224.575 129.627H224.542Z"
                fill="url(#paint7_linear_1_3826)"
            />
            <path
                d="M143.863 45.464L145.291 44.58C145.461 46.348 146.549 47.878 148.742 47.878C150.238 47.878 151.411 47.13 151.411 45.838C151.411 44.172 149.524 43.968 147.824 43.424C146.328 42.948 144.271 42.353 144.271 40.245C144.271 38.273 145.92 37.032 148.011 37.032C149.915 37.032 151.87 38.001 152.635 40.279L151.207 41.163C150.969 39.446 149.711 38.358 148.011 38.358C146.787 38.358 145.767 39.021 145.767 40.109C145.767 41.571 147.654 41.792 149.286 42.319C151.071 42.897 152.907 43.594 152.907 45.77C152.907 47.81 151.19 49.204 148.742 49.204C146.362 49.204 144.339 47.895 143.863 45.464ZM156.814 37.236H158.31V44.257C158.31 46.637 159.364 47.844 161.268 47.844C163.172 47.844 164.226 46.637 164.226 44.257V37.236H165.722V44.189C165.722 47.521 164.056 49.204 161.268 49.204C158.48 49.204 156.814 47.521 156.814 44.189V37.236ZM170.306 49V37.236H174.93C177.514 37.236 179.044 38.46 179.044 40.636C179.044 42.812 177.514 44.104 174.93 44.104H171.802V49H170.306ZM177.514 40.636C177.514 39.208 176.63 38.596 175.134 38.596H171.802V42.744H175.134C176.63 42.744 177.514 42.064 177.514 40.636ZM182.815 49V37.236H190.227V38.596H184.311V42.268H189.955V43.628H184.311V47.64H190.363V49H182.815ZM203.079 40.568C203.079 42.268 201.991 43.339 200.546 43.764L203.351 49H201.719L199.016 43.968H195.973V49H194.477V37.236H198.965C201.549 37.236 203.079 38.528 203.079 40.568ZM195.973 42.608H199.169C200.665 42.608 201.549 41.911 201.549 40.568C201.549 39.242 200.665 38.596 199.169 38.596H195.973V42.608ZM207.118 49V37.236H208.648V49H207.118ZM212.824 43.084C212.824 39.276 215.204 37.032 218.128 37.032C221.052 37.032 223.432 39.276 223.432 43.084C223.432 46.892 221.052 49.204 218.128 49.204C215.204 49.204 212.824 46.892 212.824 43.084ZM214.354 43.084C214.354 45.736 215.663 47.844 218.128 47.844C220.593 47.844 221.902 45.736 221.902 43.084C221.902 40.432 220.593 38.392 218.128 38.392C215.663 38.392 214.354 40.432 214.354 43.084ZM236.206 40.568C236.206 42.268 235.118 43.339 233.673 43.764L236.478 49H234.846L232.143 43.968H229.1V49H227.604V37.236H232.092C234.676 37.236 236.206 38.528 236.206 40.568ZM229.1 42.608H232.296C233.792 42.608 234.676 41.911 234.676 40.568C234.676 39.242 233.792 38.596 232.296 38.596H229.1V42.608Z"
                fill="url(#paint8_linear_1_3826)"
                opacity="0.78"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1_3826"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="245"
                width="379.869"
                x="0"
                y="0"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_1_3826"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_3826"
                    mode="normal"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="190"
                x2="190"
                y1="100"
                y2="122.106"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="231.56"
                x2="208.76"
                y1="110"
                y2="109.975"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="219.732"
                x2="196.932"
                y1="110"
                y2="109.975"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="206.724"
                x2="187.696"
                y1="110.031"
                y2="110.013"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="197.652"
                x2="172.795"
                y1="110"
                y2="109.971"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="185.026"
                x2="160.169"
                y1="110"
                y2="109.971"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="173.612"
                x2="147.427"
                y1="110.031"
                y2="109.997"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="280"
                x2="100.825"
                y1="133.999"
                y2="134.483"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint8_linear_1_3826"
                gradientUnits="userSpaceOnUse"
                x1="229.705"
                x2="154.611"
                y1="40"
                y2="40"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
        </defs>
    </svg>
    <svg
        v-else-if="type === 'royal'"
        fill="none"
        viewBox="0 0 380 245"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1_3856)">
            <rect
                fill="black"
                height="215"
                rx="11.9079"
                width="349.869"
                x="15"
                y="13"
            />
            <text
                dominant-baseline="middle"
                fill="#EAADA0"
                font-size="0.9rem"
                opacity="0.78"
                text-anchor="middle"
                x="190"
                y="199"
            >
                {{ uppercaseName }}
            </text>
            <path
                d="M279.5 100.5V121.606H100.5V100.5H279.5Z"
                stroke="url(#paint0_linear_1_3856)"
            />
            <path
                d="M215.584 113.19L216.983 112.324C217.15 114.057 218.216 115.556 220.364 115.556C221.83 115.556 222.979 114.823 222.979 113.557C222.979 111.925 221.13 111.725 219.465 111.192C217.999 110.725 215.984 110.142 215.984 108.077C215.984 106.145 217.599 104.929 219.648 104.929C221.513 104.929 223.429 105.879 224.178 108.11L222.779 108.977C222.546 107.294 221.314 106.228 219.648 106.228C218.449 106.228 217.449 106.878 217.449 107.944C217.449 109.376 219.298 109.593 220.897 110.109C222.646 110.675 224.445 111.358 224.445 113.49C224.445 115.489 222.763 116.855 220.364 116.855C218.032 116.855 216.05 115.572 215.584 113.19Z"
                fill="url(#paint1_linear_1_3856)"
            />
            <path
                d="M203.756 113.19L205.155 112.324C205.321 114.057 206.387 115.556 208.536 115.556C210.002 115.556 211.151 114.823 211.151 113.557C211.151 111.925 209.302 111.725 207.637 111.192C206.171 110.725 204.156 110.142 204.156 108.077C204.156 106.145 205.771 104.929 207.82 104.929C209.685 104.929 211.601 105.879 212.35 108.11L210.951 108.977C210.718 107.294 209.485 106.228 207.82 106.228C206.621 106.228 205.621 106.878 205.621 107.944C205.621 109.376 207.47 109.593 209.069 110.109C210.818 110.675 212.617 111.358 212.617 113.49C212.617 115.489 210.934 116.855 208.536 116.855C206.204 116.855 204.222 115.572 203.756 113.19Z"
                fill="url(#paint2_linear_1_3856)"
            />
            <path
                d="M193.391 116.656V105.13H200.652V106.462H194.856V110.06H200.386V111.392H194.856V115.323H200.786V116.656H193.391Z"
                fill="url(#paint3_linear_1_3856)"
            />
            <path
                d="M180.234 110.859C180.234 107.144 182.5 104.929 185.298 104.929C187.963 104.929 189.695 106.861 189.895 108.727L188.496 109.593C188.362 107.727 187.363 106.262 185.298 106.262C182.949 106.262 181.733 108.26 181.733 110.859C181.733 113.457 182.949 115.522 185.298 115.522C187.363 115.522 188.362 113.99 188.496 112.124L189.895 112.991C189.695 114.856 187.963 116.855 185.298 116.855C182.5 116.855 180.234 114.59 180.234 110.859Z"
                fill="url(#paint4_linear_1_3856)"
            />
            <path
                d="M167.608 110.859C167.608 107.144 169.874 104.929 172.672 104.929C175.337 104.929 177.069 106.861 177.269 108.727L175.87 109.593C175.736 107.727 174.737 106.262 172.672 106.262C170.323 106.262 169.107 108.26 169.107 110.859C169.107 113.457 170.323 115.522 172.672 115.522C174.737 115.522 175.736 113.99 175.87 112.124L177.269 112.991C177.069 114.856 175.337 116.855 172.672 116.855C169.874 116.855 167.608 114.59 167.608 110.859Z"
                fill="url(#paint5_linear_1_3856)"
            />
            <path
                d="M163.925 116.656L162.759 113.391H157.929L156.763 116.656H155.264L159.494 105.13H161.21L165.44 116.656H163.925ZM158.378 112.125H162.309L160.927 108.261C160.71 107.662 160.36 106.529 160.36 106.529H160.327C160.327 106.529 159.977 107.662 159.761 108.261L158.378 112.125Z"
                fill="url(#paint6_linear_1_3856)"
            />
            <path
                d="M128.662 135.111C128.662 137.445 129.696 138.629 131.562 138.629C133.429 138.629 134.463 137.445 134.463 135.111V128.228H135.93V135.045C135.93 138.312 134.296 139.962 131.562 139.962C128.829 139.962 127.195 138.312 127.195 135.045V128.228H128.662V135.111ZM118.433 128.026C121.3 128.026 123.634 130.227 123.634 133.961C123.634 137.695 121.3 139.961 118.433 139.961C115.566 139.961 113.233 137.694 113.232 133.961C113.232 130.227 115.566 128.027 118.433 128.026ZM143.431 128.026C145.297 128.026 147.214 128.977 147.964 131.21L146.564 132.077C146.331 130.394 145.097 129.326 143.431 129.326C142.231 129.326 141.231 129.976 141.23 131.043C141.23 132.476 143.08 132.693 144.681 133.21C146.431 133.777 148.231 134.46 148.231 136.594C148.231 138.594 146.548 139.961 144.147 139.961C141.814 139.961 139.83 138.678 139.363 136.294L140.764 135.428C140.93 137.161 141.997 138.661 144.147 138.661C145.614 138.661 146.764 137.928 146.765 136.661C146.765 135.028 144.914 134.827 143.247 134.294C141.78 133.827 139.764 133.244 139.764 131.177C139.764 129.243 141.38 128.026 143.431 128.026ZM166.176 128.026C168.043 128.026 169.959 128.977 170.709 131.21L169.31 132.077C169.076 130.394 167.843 129.326 166.176 129.326C164.976 129.326 163.976 129.976 163.976 131.043C163.976 132.476 165.826 132.693 167.426 133.21C169.176 133.777 170.976 134.46 170.977 136.594C170.977 138.594 169.293 139.961 166.893 139.961C164.559 139.961 162.575 138.678 162.108 136.294L163.509 135.428C163.676 137.161 164.742 138.661 166.893 138.661C168.359 138.661 169.51 137.928 169.51 136.661C169.51 135.028 167.659 134.827 165.992 134.294C164.525 133.827 162.509 133.244 162.509 131.177C162.509 129.243 164.126 128.026 166.176 128.026ZM184.44 128.026C187.307 128.026 189.642 130.227 189.642 133.961C189.641 137.695 187.307 139.961 184.44 139.961C181.574 139.961 179.24 137.694 179.24 133.961C179.24 130.227 181.574 128.027 184.44 128.026ZM102.257 133.161H108.124V128.228H109.591V139.762H108.124V134.494H102.257V139.762H100.79V128.228H102.257V133.161ZM159.002 129.561H153.201V133.161H158.735V134.494H153.201V138.429H159.136V139.762H151.734V128.228H159.002V129.561ZM200.403 129.561H194.736V133.228H200.137V134.562H194.736V139.762H193.27V128.228H200.403V129.561ZM210.24 132.294C210.24 133.419 210.207 134.414 210.207 134.428H210.24C210.249 134.415 210.813 133.57 211.674 132.561L215.341 128.228H217.141L213.374 132.628L217.841 139.762H216.157L212.407 133.744L210.24 136.278V139.762H208.807V128.228H210.24V132.294ZM229.659 139.762H228.143L226.976 136.495H222.142L220.975 139.762H219.475L223.708 128.228H225.426L229.659 139.762ZM236.558 128.228C239.825 128.228 242.092 130.227 242.092 133.961C242.092 137.695 239.825 139.762 236.558 139.762H232.69V128.228H236.558ZM253 129.561H247.199V133.161H252.733V134.494H247.199V138.429H253.134V139.762H245.732V128.228H253V129.561ZM258.872 136.661C258.988 137.242 259.122 138.284 259.123 138.295H259.156C259.159 138.279 259.34 137.24 259.473 136.661L261.473 128.228H263.307L265.307 136.661C265.439 137.24 265.62 138.279 265.623 138.295H265.656C265.658 138.284 265.791 137.242 265.907 136.661L267.674 128.228H269.141L266.59 139.762H264.724L262.723 131.428C262.525 130.621 262.393 129.716 262.39 129.694H262.356C262.353 129.716 262.22 130.621 262.022 131.428L260.022 139.762H258.156L255.605 128.228H257.105L258.872 136.661ZM279.473 129.561H273.672V133.161H279.206V134.494H273.672V138.429H279.606V139.762H272.205V128.228H279.473V129.561ZM118.433 129.36C116.016 129.361 114.732 131.361 114.732 133.961C114.733 136.561 116.016 138.628 118.433 138.628C120.849 138.628 122.134 136.561 122.134 133.961C122.134 131.361 120.85 129.36 118.433 129.36ZM184.44 129.36C182.024 129.361 180.74 131.361 180.74 133.961C180.74 136.561 182.024 138.628 184.44 138.628C186.857 138.628 188.141 136.561 188.142 133.961C188.142 131.361 186.857 129.36 184.44 129.36ZM234.157 138.429H236.975C239.275 138.429 240.592 136.494 240.592 133.961C240.592 131.427 239.275 129.561 236.975 129.561H234.157V138.429ZM224.542 129.627C224.542 129.627 224.192 130.76 223.976 131.36L222.592 135.228H226.525L225.142 131.36C224.925 130.76 224.575 129.627 224.575 129.627H224.542Z"
                fill="url(#paint7_linear_1_3856)"
            />
            <path
                d="M170.819 40.568C170.819 42.268 169.731 43.339 168.286 43.764L171.091 49H169.459L166.756 43.968H163.713V49H162.217V37.236H166.705C169.289 37.236 170.819 38.528 170.819 40.568ZM163.713 42.608H166.909C168.405 42.608 169.289 41.911 169.289 40.568C169.289 39.242 168.405 38.596 166.909 38.596H163.713V42.608ZM174.248 43.084C174.248 39.276 176.628 37.032 179.552 37.032C182.476 37.032 184.856 39.276 184.856 43.084C184.856 46.892 182.476 49.204 179.552 49.204C176.628 49.204 174.248 46.892 174.248 43.084ZM175.778 43.084C175.778 45.736 177.087 47.844 179.552 47.844C182.017 47.844 183.326 45.736 183.326 43.084C183.326 40.432 182.017 38.392 179.552 38.392C177.087 38.392 175.778 40.432 175.778 43.084ZM191.149 49V44.41L187.12 37.236H188.735L191.098 41.571C191.506 42.319 191.897 43.135 191.897 43.135H191.931C191.931 43.135 192.322 42.319 192.73 41.571L195.11 37.236H196.674L192.645 44.41V49H191.149ZM206.697 49L205.507 45.668H200.577L199.387 49H197.857L202.175 37.236H203.926L208.244 49H206.697ZM201.036 44.376H205.048L203.637 40.432C203.416 39.82 203.059 38.664 203.059 38.664H203.025C203.025 38.664 202.668 39.82 202.447 40.432L201.036 44.376ZM211.804 49V37.236H213.3V47.64H218.944V49H211.804Z"
                fill="url(#paint8_linear_1_3856)"
                opacity="0.78"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1_3856"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="245"
                width="379.869"
                x="0"
                y="0"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_1_3856"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_3856"
                    mode="normal"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="280"
                x2="100"
                y1="111"
                y2="111"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#EC9991"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="231.432"
                x2="208.884"
                y1="113"
                y2="112.951"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="219.604"
                x2="197.055"
                y1="113"
                y2="112.951"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="206.617"
                x2="187.799"
                y1="112.93"
                y2="112.895"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="197.513"
                x2="172.929"
                y1="113"
                y2="112.941"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="184.887"
                x2="160.303"
                y1="113"
                y2="112.941"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="173.465"
                x2="147.568"
                y1="112.93"
                y2="112.863"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="285"
                x2="101"
                y1="134"
                y2="134"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
            <linearGradient
                id="paint8_linear_1_3856"
                gradientUnits="userSpaceOnUse"
                x1="233"
                x2="147"
                y1="49"
                y2="47"
            >
                <stop stop-color="#EAADA0" />
                <stop
                    offset="0.24"
                    stop-color="#F9D0C2"
                />
                <stop
                    offset="1"
                    stop-color="#B88172"
                />
            </linearGradient>
        </defs>
    </svg>
    <svg
        v-else-if="type === 'foth'"
        fill="none"
        viewBox="0 0 380 245"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1_3886)">
            <rect
                fill="black"
                height="215"
                rx="11.9079"
                width="349.869"
                x="15"
                y="13"
            />
            <text
                dominant-baseline="middle"
                fill="#E9E9E9"
                font-size="0.9rem"
                opacity="0.78"
                text-anchor="middle"
                x="190"
                y="199"
            >
                {{ uppercaseName }}
            </text>
            <path
                d="M279.5 100.5V121.606H100.5V100.5H279.5Z"
                stroke="url(#paint0_linear_1_3886)"
            />
            <path
                d="M215.584 113.19L216.983 112.324C217.15 114.057 218.216 115.556 220.364 115.556C221.83 115.556 222.979 114.823 222.979 113.557C222.979 111.925 221.13 111.725 219.465 111.192C217.999 110.725 215.984 110.142 215.984 108.077C215.984 106.145 217.599 104.929 219.648 104.929C221.513 104.929 223.429 105.879 224.178 108.11L222.779 108.977C222.546 107.294 221.314 106.228 219.648 106.228C218.449 106.228 217.449 106.878 217.449 107.944C217.449 109.376 219.298 109.593 220.897 110.109C222.646 110.675 224.445 111.358 224.445 113.49C224.445 115.489 222.763 116.855 220.364 116.855C218.032 116.855 216.05 115.572 215.584 113.19Z"
                fill="url(#paint1_linear_1_3886)"
            />
            <path
                d="M203.756 113.19L205.155 112.324C205.321 114.057 206.387 115.556 208.536 115.556C210.002 115.556 211.151 114.823 211.151 113.557C211.151 111.925 209.302 111.725 207.637 111.192C206.171 110.725 204.156 110.142 204.156 108.077C204.156 106.145 205.771 104.929 207.82 104.929C209.685 104.929 211.601 105.879 212.35 108.11L210.951 108.977C210.718 107.294 209.485 106.228 207.82 106.228C206.621 106.228 205.621 106.878 205.621 107.944C205.621 109.376 207.47 109.593 209.069 110.109C210.818 110.675 212.617 111.358 212.617 113.49C212.617 115.489 210.934 116.855 208.536 116.855C206.204 116.855 204.222 115.572 203.756 113.19Z"
                fill="url(#paint2_linear_1_3886)"
            />
            <path
                d="M193.391 116.656V105.13H200.652V106.462H194.856V110.06H200.386V111.392H194.856V115.323H200.786V116.656H193.391Z"
                fill="url(#paint3_linear_1_3886)"
            />
            <path
                d="M180.234 110.859C180.234 107.144 182.5 104.929 185.298 104.929C187.963 104.929 189.695 106.861 189.895 108.727L188.496 109.593C188.362 107.727 187.363 106.262 185.298 106.262C182.949 106.262 181.733 108.26 181.733 110.859C181.733 113.457 182.949 115.522 185.298 115.522C187.363 115.522 188.362 113.99 188.496 112.124L189.895 112.991C189.695 114.856 187.963 116.855 185.298 116.855C182.5 116.855 180.234 114.59 180.234 110.859Z"
                fill="url(#paint4_linear_1_3886)"
            />
            <path
                d="M167.608 110.859C167.608 107.144 169.874 104.929 172.672 104.929C175.337 104.929 177.069 106.861 177.269 108.727L175.87 109.593C175.736 107.727 174.737 106.262 172.672 106.262C170.323 106.262 169.107 108.26 169.107 110.859C169.107 113.457 170.323 115.522 172.672 115.522C174.737 115.522 175.736 113.99 175.87 112.124L177.269 112.991C177.069 114.856 175.337 116.855 172.672 116.855C169.874 116.855 167.608 114.59 167.608 110.859Z"
                fill="url(#paint5_linear_1_3886)"
            />
            <path
                d="M163.925 116.656L162.759 113.391H157.929L156.763 116.656H155.264L159.494 105.13H161.21L165.44 116.656H163.925ZM158.378 112.125H162.309L160.927 108.261C160.71 107.662 160.36 106.529 160.36 106.529H160.327C160.327 106.529 159.977 107.662 159.761 108.261L158.378 112.125Z"
                fill="url(#paint6_linear_1_3886)"
            />
            <path
                d="M128.662 135.111C128.662 137.445 129.696 138.629 131.562 138.629C133.429 138.629 134.463 137.445 134.463 135.111V128.228H135.93V135.045C135.93 138.312 134.296 139.962 131.562 139.962C128.829 139.962 127.195 138.312 127.195 135.045V128.228H128.662V135.111ZM118.433 128.026C121.3 128.026 123.634 130.227 123.634 133.961C123.634 137.695 121.3 139.961 118.433 139.961C115.566 139.961 113.233 137.694 113.232 133.961C113.232 130.227 115.566 128.027 118.433 128.026ZM143.431 128.026C145.297 128.026 147.214 128.977 147.964 131.21L146.564 132.077C146.331 130.394 145.097 129.326 143.431 129.326C142.231 129.326 141.231 129.976 141.23 131.043C141.23 132.476 143.08 132.693 144.681 133.21C146.431 133.777 148.231 134.46 148.231 136.594C148.231 138.594 146.548 139.961 144.147 139.961C141.814 139.961 139.83 138.678 139.363 136.294L140.764 135.428C140.93 137.161 141.997 138.661 144.147 138.661C145.614 138.661 146.764 137.928 146.765 136.661C146.765 135.028 144.914 134.827 143.247 134.294C141.78 133.827 139.764 133.244 139.764 131.177C139.764 129.243 141.38 128.026 143.431 128.026ZM166.176 128.026C168.043 128.026 169.959 128.977 170.709 131.21L169.31 132.077C169.076 130.394 167.843 129.326 166.176 129.326C164.976 129.326 163.976 129.976 163.976 131.043C163.976 132.476 165.826 132.693 167.426 133.21C169.176 133.777 170.976 134.46 170.977 136.594C170.977 138.594 169.293 139.961 166.893 139.961C164.559 139.961 162.575 138.678 162.108 136.294L163.509 135.428C163.676 137.161 164.742 138.661 166.893 138.661C168.359 138.661 169.51 137.928 169.51 136.661C169.51 135.028 167.659 134.827 165.992 134.294C164.525 133.827 162.509 133.244 162.509 131.177C162.509 129.243 164.126 128.026 166.176 128.026ZM184.44 128.026C187.307 128.026 189.642 130.227 189.642 133.961C189.641 137.695 187.307 139.961 184.44 139.961C181.574 139.961 179.24 137.694 179.24 133.961C179.24 130.227 181.574 128.027 184.44 128.026ZM102.257 133.161H108.124V128.228H109.591V139.762H108.124V134.494H102.257V139.762H100.79V128.228H102.257V133.161ZM159.002 129.561H153.201V133.161H158.735V134.494H153.201V138.429H159.136V139.762H151.734V128.228H159.002V129.561ZM200.403 129.561H194.736V133.228H200.137V134.562H194.736V139.762H193.27V128.228H200.403V129.561ZM210.24 132.294C210.24 133.419 210.207 134.414 210.207 134.428H210.24C210.249 134.415 210.813 133.57 211.674 132.561L215.341 128.228H217.141L213.374 132.628L217.841 139.762H216.157L212.407 133.744L210.24 136.278V139.762H208.807V128.228H210.24V132.294ZM229.659 139.762H228.143L226.976 136.495H222.142L220.975 139.762H219.475L223.708 128.228H225.426L229.659 139.762ZM236.558 128.228C239.825 128.228 242.092 130.227 242.092 133.961C242.092 137.695 239.825 139.762 236.558 139.762H232.69V128.228H236.558ZM253 129.561H247.199V133.161H252.733V134.494H247.199V138.429H253.134V139.762H245.732V128.228H253V129.561ZM258.872 136.661C258.988 137.242 259.122 138.284 259.123 138.295H259.156C259.159 138.279 259.34 137.24 259.473 136.661L261.473 128.228H263.307L265.307 136.661C265.439 137.24 265.62 138.279 265.623 138.295H265.656C265.658 138.284 265.791 137.242 265.907 136.661L267.674 128.228H269.141L266.59 139.762H264.724L262.723 131.428C262.525 130.621 262.393 129.716 262.39 129.694H262.356C262.353 129.716 262.22 130.621 262.022 131.428L260.022 139.762H258.156L255.605 128.228H257.105L258.872 136.661ZM279.473 129.561H273.672V133.161H279.206V134.494H273.672V138.429H279.606V139.762H272.205V128.228H279.473V129.561ZM118.433 129.36C116.016 129.361 114.732 131.361 114.732 133.961C114.733 136.561 116.016 138.628 118.433 138.628C120.849 138.628 122.134 136.561 122.134 133.961C122.134 131.361 120.85 129.36 118.433 129.36ZM184.44 129.36C182.024 129.361 180.74 131.361 180.74 133.961C180.74 136.561 182.024 138.628 184.44 138.628C186.857 138.628 188.141 136.561 188.142 133.961C188.142 131.361 186.857 129.36 184.44 129.36ZM234.157 138.429H236.975C239.275 138.429 240.592 136.494 240.592 133.961C240.592 131.427 239.275 129.561 236.975 129.561H234.157V138.429ZM224.542 129.627C224.542 129.627 224.192 130.76 223.976 131.36L222.592 135.228H226.525L225.142 131.36C224.925 130.76 224.575 129.627 224.575 129.627H224.542Z"
                fill="url(#paint7_linear_1_3886)"
            />
            <path
                d="M157.656 49V37.236H164.932V38.596H159.152V42.336H164.66V43.696H159.152V49H157.656ZM177.505 40.568C177.505 42.268 176.417 43.339 174.972 43.764L177.777 49H176.145L173.442 43.968H170.399V49H168.903V37.236H173.391C175.975 37.236 177.505 38.528 177.505 40.568ZM170.399 42.608H173.595C175.091 42.608 175.975 41.911 175.975 40.568C175.975 39.242 175.091 38.596 173.595 38.596H170.399V42.608ZM181.545 49V37.236H183.075V49H181.545ZM187.795 49V37.236H195.207V38.596H189.291V42.268H194.935V43.628H189.291V47.64H195.343V49H187.795ZM208.569 49H206.393L201.956 40.84C201.514 40.024 200.902 38.749 200.902 38.749H200.868C200.868 38.749 200.919 39.837 200.919 40.976V49H199.457V37.236H201.633L206.07 45.396C206.512 46.212 207.124 47.504 207.124 47.504H207.158C207.158 47.504 207.107 46.399 207.107 45.26V37.236H208.569V49ZM213.294 37.236H217.238C220.57 37.236 222.882 39.276 222.882 43.084C222.882 46.892 220.57 49 217.238 49H213.294V37.236ZM214.79 38.596V47.64H217.663C220.009 47.64 221.352 45.668 221.352 43.084C221.352 40.5 220.009 38.596 217.663 38.596H214.79Z"
                fill="#E9E9E9"
                opacity="0.78"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1_3886"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
                height="245"
                width="379.869"
                x="0"
                y="0"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_1_3886"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1_3886"
                    mode="normal"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="100"
                x2="280"
                y1="111"
                y2="111"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="208.506"
                x2="231.817"
                y1="107.5"
                y2="107.5"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="196.678"
                x2="219.988"
                y1="107.5"
                y2="107.5"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="187.483"
                x2="206.938"
                y1="107.615"
                y2="107.615"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="172.518"
                x2="197.931"
                y1="107.5"
                y2="107.5"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="159.892"
                x2="185.306"
                y1="107.5"
                y2="107.5"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="147.134"
                x2="173.907"
                y1="107.615"
                y2="107.615"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_1_3886"
                gradientUnits="userSpaceOnUse"
                x1="101"
                x2="280"
                y1="131"
                y2="131"
            >
                <stop stop-color="#A3A3A3" />
                <stop
                    offset="1"
                    stop-color="#525252"
                />
            </linearGradient>
        </defs>
    </svg>
</template>

<script lang="ts" setup>
import type { CardType } from "~/types";

const props = defineProps<{
    name: string;
    type: CardType;
}>();

const uppercaseName = computed(() => props.name.toUpperCase());
</script>

<style scoped>
svg {
    filter: drop-shadow(0 2px 15px rgba(0, 0, 0, 0.08));
}
</style>
